import { CardModal } from '@mindly/ui-components';
import AdditionalCheckoutPromocodeWidget from 'src/widgets/AdditionalCheckoutPromocodeWidget';

type AdditionalCheckoutPromocodeModalFeatureProps = {
  isOpen: boolean;
  onClose: () => void;
  onGetDiscountClick: () => void;
  discount: number;
} & React.ComponentProps<typeof CardModal>;

const AdditionalCheckoutPromocodeModalFeature = ({
  isOpen,
  onClose,
  onGetDiscountClick,
  discount,
  ...modalProps
}: AdditionalCheckoutPromocodeModalFeatureProps) => {
  return (
    <CardModal
      {...modalProps}
      isShowHandle={false}
      isOpen={isOpen}
      onDidDismiss={onClose}
      isShowCloseButton={false}
      canDismiss={isOpen}
    >
      <AdditionalCheckoutPromocodeWidget onGetDiscountClick={onGetDiscountClick} discount={discount} />
    </CardModal>
  );
};

export default AdditionalCheckoutPromocodeModalFeature;
